module.exports = __webpack_public_path__ + "static/media/curology-min.e84c2055.png";